export default __webpack_public_path__ + "static/media/lupasearch.7cd23725.svg";